import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

// Provider OAuth endpoints and scopes
const SOCIAL_PROVIDERS = {
  microsoft: {
    label: 'Microsoft',
    authUrl: (clientId, redirectUri, state) => {
      const params = new URLSearchParams({
        client_id: clientId,
        redirect_uri: redirectUri,
        response_type: 'code',
        scope: 'openid profile email',
        response_mode: 'query',
        state
      });
      return `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?${params}`;
    },
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
    icon: (
      <svg width="18" height="18" viewBox="0 0 21 21" fill="none" aria-hidden="true">
        <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
        <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
        <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
        <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
      </svg>
    )
  },
  google: {
    label: 'Google',
    authUrl: (clientId, redirectUri, state) => {
      const params = new URLSearchParams({
        client_id: clientId,
        redirect_uri: redirectUri,
        response_type: 'code',
        scope: 'openid profile email',
        state
      });
      return `https://accounts.google.com/o/oauth2/v2/auth?${params}`;
    },
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
      </svg>
    )
  }
};

function generateNonce(len = 24) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < len; i++) result += chars[Math.floor(Math.random() * chars.length)];
  return result;
}

function LoginScreen() {
  const location = useLocation();
  const [error, setError] = useState(location.state?.error || '');
  const [loading, setLoading] = useState(false);

  const handleSocialLogin = (providerKey) => {
    const provider = SOCIAL_PROVIDERS[providerKey];
    const clientId = provider.clientId;

    if (!clientId) {
      setError(`${provider.label} sign-in is not configured yet.`);
      return;
    }

    const nonce = generateNonce();
    sessionStorage.setItem('social_oauth_state', nonce);
    sessionStorage.setItem('social_oauth_provider', providerKey);

    const redirectUri = `${window.location.origin}/auth/social/callback`;
    window.location.href = provider.authUrl(clientId, redirectUri, nonce);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Creative Work Footprint</h1>
          <p className="auth-subtitle">Discover Your Creative Profile</p>
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="social-buttons">
          {Object.entries(SOCIAL_PROVIDERS).map(([key, provider]) => (
            <button
              key={key}
              type="button"
              className="btn btn-social"
              onClick={() => handleSocialLogin(key)}
              disabled={loading}
            >
              {provider.icon}
              Sign in with {provider.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LoginScreen;
